import { render, staticRenderFns } from "./RectangleAttr.vue?vue&type=template&id=891089d6&scoped=true&"
import script from "./RectangleAttr.vue?vue&type=script&lang=js&"
export * from "./RectangleAttr.vue?vue&type=script&lang=js&"
import style0 from "./RectangleAttr.vue?vue&type=style&index=0&id=891089d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891089d6",
  null
  
)

export default component.exports